import {confirmed, email, length, numeric, required} from 'vee-validate/dist/rules'
import {extend} from 'vee-validate'

extend('required', {
  ...required,
  message: 'This field is required'
})

extend('email', {
  ...email,
  message: 'This field must be a valid email'
})

extend('confirmed', {
  ...confirmed,
  message: 'This field confirmation does not match'
})

extend('length', {
  ...length,
  message: 'This field must have 2 options'
})

extend('numeric', {
  ...numeric,
  message: 'This field must be a valid numeric'
})

extend('number', {
  validate: value => {
    if (typeof value === 'string') {
      const exp = /^-?\+?[0-9]\d*(\.\d+)?(,\d+)?$/g
      return value.match(exp)
    }
  },
  message: 'This field must be a valid number'
})
